import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/shared/api';

export type SubscriptionAction =
  'cancel' | 'pause' | 'reactivate' | 'shipNow' | 'changeDispatchDate';

export const CANCELLATION_REASONS = {
  '2|Overstocked': 'I have food leftover',
  "15|Doesn't like product": "The food didn't go down well",
  '8|To expensive': "It's too expensive",
  '23|My pet passed away': 'My cat passed away',
  '33|No longer wants a subscription': "A subscription doesn't work for me",
  '42|Temporary Cancel': "I'm coming back",
  '1|Other (Subscriber input)': 'Other',
} as const;

export const PAUSE_REASONS = {
  '2|Overstocked': 'I have food leftover',
  "15|Doesn't like product": "The food didn't go down well",
  '8|To expensive': "It's too expensive",
  '33|No longer wants a subscription': "A subscription doesn't work for me",
  '1|Other (Subscriber input)': 'Other',
} as const;

export interface CancelPauseRequest {
  reasonId: string;
  comment?: string;
}

export interface ChangeDispatchDateRequest {
  nextDispatchDate: string;
}

export class SubscriptionActionService {
  static async cancel(shopifyCustomerId: number, request: CancelPauseRequest): Promise<void> {
    await api.put(API_ENDPOINTS.CUSTOMERS.SUBSCRIPTION_CANCEL(shopifyCustomerId), request);
  }

  static async pause(shopifyCustomerId: number, request: CancelPauseRequest): Promise<void> {
    await api.put(API_ENDPOINTS.CUSTOMERS.SUBSCRIPTION_PAUSE(shopifyCustomerId), request);
  }

  static async reactivate(shopifyCustomerId: number): Promise<unknown> {
    const response = await api.put(
      API_ENDPOINTS.CUSTOMERS.SUBSCRIPTION_REACTIVATE(shopifyCustomerId),
    );
    return response.data;
  }

  static async shipNow(shopifyCustomerId: number): Promise<unknown> {
    const response = await api.put(API_ENDPOINTS.CUSTOMERS.ORDER_SHIP_NOW(shopifyCustomerId));
    return response.data;
  }

  static async changeDispatchDate(
    shopifyCustomerId: number,
    request: ChangeDispatchDateRequest,
  ): Promise<void> {
    await api.put(API_ENDPOINTS.CUSTOMERS.ORDER_CHANGE_DATE(shopifyCustomerId), {
      nextDispatchDate: request.nextDispatchDate,
    });
  }

  /**
   * Locks the customer's Purrscribe account (admin).
   */
  static async lock(shopifyCustomerId: number): Promise<void> {
    await api.put(API_ENDPOINTS.CUSTOMERS.SUBSCRIPTION_LOCK(shopifyCustomerId));
  }

  /**
   * Unlocks the customer's Purrscribe account (admin).
   */
  static async unlock(shopifyCustomerId: number): Promise<void> {
    await api.put(API_ENDPOINTS.CUSTOMERS.SUBSCRIPTION_UNLOCK(shopifyCustomerId));
  }
}
